<template>
  <div class="flex items-center text-lg gap-2 h-8">
    <input
      ref="refLeft"
      v-model="left"
      class="border border-gray-400 rounded-md outline-none overflow-hidden py-1 px-2 w-16"
      type="text"
      pattern="\d*"
      maxlength="3"
      inputmode="decimal"
      placeholder="123"
      @input="onLeftInput"
      @paste="onPaste"
    />
    <span>
      -
    </span>
    <input
      ref="refRight"
      v-model="right"
      class="border border-gray-400 rounded-md outline-none overflow-hidden py-1 px-2 w-20"
      type="text"
      pattern="\d*"
      maxlength="4"
      inputmode="decimal"
      placeholder="4567"
      @input="onRightInput"
      @paste="onPaste"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, Ref, ref } from 'vue';

export default defineComponent({
  name: 'SurveyInputPostalCode',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const left = ref(filterNumber(props.modelValue).slice(0, 3));
    const right = ref(filterNumber(props.modelValue).slice(3, 7));
    const refLeft: Ref<HTMLInputElement | null> = ref(null);
    const refRight: Ref<HTMLInputElement | null> = ref(null);

    /**
     * 左に入力したとき
     */
    const onLeftInput = (event: Event) => {
      const input = event.target as HTMLInputElement;
      const value = filterNumber(input.value);
      left.value = value;

      onUpdate();

      // 左に 3 文字入力したら右にフォーカス
      if (value.length === 3) {
        refRight.value?.focus();
      }
    };

    /**
     * 右に入力したとき
     */
    const onRightInput = (event: Event) => {
      const input = event.target as HTMLInputElement;
      const value = filterNumber(input.value);
      right.value = value;

      onUpdate();

      // 右を 0 文字にしたら左にフォーカス
      if (value.length === 0) {
        refLeft.value?.focus();
      }
    };

    /**
     * 貼り付けたとき
     */
    const onPaste = (event: ClipboardEvent) => {
      event.preventDefault();
      const text = event.clipboardData?.getData('text') ?? '';
      const value = filterNumber(text);
      left.value = value.slice(0, 3);
      right.value = value.slice(3, 7);

      onUpdate();
    };

    const onUpdate = () => {
      emit('update:modelValue', left.value + right.value);
    };

    /**
     * 数値以外を取り除く
     */
    function filterNumber(value: string) {
      return value.replace(/\D/g, '');
    }

    return {
      left,
      right,
      onLeftInput,
      onRightInput,
      onPaste,
      refLeft,
      refRight,
    };
  },
});
</script>
